import React from 'react'
import { useExportTripPoint, useGetTripPoints } from '../../api/point'
import { PointPanelScreen } from '../shared/PointPanelScreen'
import { LUBRICANT } from '../../constant/htg-companies'

export const MobilChinaTripPoints = () => {
  const columns = [
    { id: 'companyAccountId', label: 'Company Id' },
    { id: 'companyName', label: 'Company Name' },
    { id: 'totalPoint', label: 'Total Points' },
    { id: 'salesId', label: 'Sales Id' },
  ]

  return (
    <PointPanelScreen
      title='Mobil China Trip Point 2' // 2.0 is not possible due to interfering with export file type
      htgCompany={LUBRICANT}
      useExportApi={useExportTripPoint}
      useGetPoints={useGetTripPoints}
      columns={columns}
      linkBase='trip-summary'
    />
  )
}
